import { useEffect, useState } from 'react';
import { createTheme, Dialog, styled, ThemeProvider } from '@mui/material';
import images from '../../assets/images';
import './VideoViewer.scss';
import { useDispatch } from 'react-redux';
import { setCurrentVideoData } from '../../redux/slices/dashboardSlice';
import { VideosListForCategory } from '../../pages/SyndicatedVideos/SyndicatedVideos';
// import { RecorderPtaMeetingType } from '../../pages/AdminPta/AdminPta';
import { CordovaFileDetail, ElectronFileDetail } from '../../utils/interface';

const theme= createTheme({
    components: {
      MuiBackdrop: {
        styleOverrides: {
          root: {
            backgroundColor: "black",
          },
        },
      },
    }}
  )

// Create a styled Dialog component
const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiPaper-root': {
      display: 'block',
      maxWidth: '78%',
      maxHeight: '97%',
      overflow: 'hidden'
    },
  }));

interface videoViewerProps{
    video:string;
    onClose: () => void;
    type:string;
    videoRef?: any;
    videoId?: string;
    videoData: VideosListForCategory | undefined | CordovaFileDetail | ElectronFileDetail | null;
}

const VideoViewer = ({video, onClose, type, videoRef,videoId, videoData}:videoViewerProps) => {
    const [clickedExpandView, setClickedExpandView] = useState<boolean>(false);
    const dispatch = useDispatch();

    const {whiteCrossIcon, expandVideoIcon} = images;
    const onClickExpandIcon = () => {
        setClickedExpandView(true);
    }
  
    const onClickCloseIcon = () => {
      if(videoRef){
        dispatch(setCurrentVideoData({
          videoCurrentTime: videoRef.current.currentTime,
          videoId: videoId||''
        }))
      }
      onClose();
      setClickedExpandView(false);
    }

    const handleOnMouseOut = () => {
        if(videoRef){
          dispatch(setCurrentVideoData({
            videoCurrentTime: videoRef.current.currentTime,
            videoId: videoId||''
          }))
        }
    }

    useEffect(() => {
      if(videoRef && videoData?.playbackTime){
        videoRef.current.currentTime = parseFloat(videoData?.playbackTime);
      }
    },[]);

  return (
    <div className='videoViewer'>
      <div className={`detailView ${type === "Virtual Class Sessions" ? 'virtualClassSession' :  ''}`}>
      <video
          src={video}
          ref={videoRef}
          autoPlay
          onMouseOut={handleOnMouseOut}          
          disablePictureInPicture
          controls
          controlsList='nodownload noplaybackrate'
          loop
          className='detailVideoTagStyle'
          style={{ display: clickedExpandView ? 'none' : 'flex', outline: 'none', border: 'none' }}
        />
      </div>
      <img
        src={whiteCrossIcon}
        className={clickedExpandView ? 'expandCrossIcon' : 'whiteCrossIcon'}
        onClick={onClickCloseIcon}
        alt='Close Icon'
      />
      <img
        src={expandVideoIcon}
        className='whiteExpandIcon'
        onClick={onClickExpandIcon}
        alt='Expand Icon'
      />
      {clickedExpandView && (
        <ThemeProvider theme={theme}>
          <StyledDialog
            open={clickedExpandView}
            classes={{ paper: 'VideoExpandPaperStyle' }}
            onClose={onClickCloseIcon} // Ensure the dialog can be closed
          >
            <video
              src={video}
              autoPlay
              controls
              loop
              disablePictureInPicture
              controlsList='nodownload noplaybackrate'
              className='expandVideoTagStyle'
              style={{ width: '100%', height: '100vh', outline: 'none', border: 'none', objectFit: 'initial' }}
            />
          </StyledDialog>
        </ThemeProvider>
      )}
    </div>
  );
};

export default VideoViewer;
